import { render, staticRenderFns } from "./date-of-birth.vue?vue&type=template&id=15e505be"
import script from "./date-of-birth.vue?vue&type=script&lang=js"
export * from "./date-of-birth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports